import { Visibility } from '@mui/icons-material';
import { Grid, IconButton, useEventCallback } from '@mui/material';
import { memo, ReactElement, useMemo, useState } from 'react';
import Table from 'shell/components/shared/table';
import { BaseTableRows, HeadCell } from 'shell/components/shared/table/types';
import { noop } from 'shell/utils/noop';
import { FamilyVM } from '../family/family-vm';

export interface TableFamilyVM extends FamilyVM, BaseTableRows {
  gender?: string;
  action: ReactElement;
}

const headCells: HeadCell<TableFamilyVM, keyof TableFamilyVM>[] = [
  {
    id: 'fiscalCode',
    label: 'Codice Fiscale',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'gender',
    label: 'Sesso',
  },
  {
    id: 'birthDate',
    label: 'Data di nascita',
  },
  {
    id: 'birthplace',
    label: 'Luogo di nascita',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

interface TablePersonProps {
  data: Array<FamilyVM>;
  onVisibilityPress: (value: FamilyVM) => void;
}

const TablePersonComponent = ({
  data,
  onVisibilityPress,
}: TablePersonProps): React.ReactElement => {
  const [tableProps, setTableProps] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const onChangePage = useEventCallback((page: number) => {
    setTableProps({
      rowsPerPage: tableProps.rowsPerPage,
      page,
    });
  });

  const onChangeRowsPerPage = useEventCallback((rowsPerPage: number) => {
    setTableProps({
      rowsPerPage,
      page: 0,
    });
  });

  const body: Array<TableFamilyVM> = useMemo(() => {
    if ((data || []).length === 0) {
      return [];
    }

    return data.map((item: FamilyVM) => ({
      fiscalCode: item.fiscalCode || '',
      surname: item.surname || '',
      name: item.name || '',
      gender: item.generality?.gender || '',
      birthDate: item.birthDate || '',
      birthplace: item.birthplace || '',
      action: (
        <IconButton
          aria-label="visualizza"
          component="span"
          onClick={() => onVisibilityPress(item)}
        >
          <Visibility />
        </IconButton>
      ),
    })) as Array<TableFamilyVM>;
  }, [data]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Table
          ariaLabel="Lista Persone"
          page={tableProps.page}
          rowsPerPage={tableProps.rowsPerPage}
          body={body}
          count={body?.length || 0}
          head={headCells}
          onSort={noop}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
          orders={{}}
          isNotLayoutFixed
          noSort
          hideButtons
        />
      </Grid>
    </Grid>
  );
};

TablePersonComponent.displayName = 'Table person form component';

const TablePerson = memo(TablePersonComponent);

export default TablePerson;
